import * as Styled from './SubscriptionResourceAssignment.styles';
import AddIcon from '@mui/icons-material/Add';
// import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Button } from '@cw-ui/form-components';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';
// import { useSelector } from 'react-redux';
// import { subscribersSliceId } from '../../slice';

const SubscriptionResourceAssignment = ({ handleSetResourcesAccess }) => {
    return (
        <Styled.ButtonContainer>
            {/* For Future use case-IAM-14135 */}
            {/* <Button
                color="ghost"
                endIcon={<VisibilityOutlinedIcon fontSize="medium" />}
                size="medium"
                disabled
                // skeleton={isResourcesReady}
                variant="outlined">
                {`${totalResourcesCount} Assigned Resources`}
            </Button> */}
            <Button
                color="ghost"
                endIcon={<AddIcon fontSize="medium" />}
                size="medium"
                variant="outlined"
                onClick={handleSetResourcesAccess}>
                {formatMessage(Locale.addResources)}
            </Button>
        </Styled.ButtonContainer>
    );
};

export default SubscriptionResourceAssignment;
